const mapEnglishText = {
  MULTIPLE_PROPERTIES: "Multiple properties",
  PRICE_SMALL: "Price",
  SAVE_AND_CONT: "Save And Next",
};

export default mapEnglishText;
